import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Esto es médico?',
    a: 'No. Es educativo. Se basa en hábitos de estilo de vida (sueño, luz, alimentación, respiración). Siempre consultá a tu profesional médico para temas de salud.'
  }, {
    q: '¿Necesito gimnasio o equipamiento?',
    a: 'No. Es una rutina mínima que podés hacer en casa. No necesitás comprar nada extra.'
  }, {
    q: '¿Cuánto tiempo por día?',
    a: '20 minutos total (10 AM + 10 PM). Y incluimos una versión “mínima” de 3 minutos para los días difíciles donde no tenés tiempo.'
  }];
  return <Section className="max-w-3xl mx-auto pb-24" data-id="element-1">
      <h2 className="text-2xl md:text-3xl font-serif text-center mb-10 text-brand-text" data-id="element-2">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-4" data-id="element-3">
        {faqs.map((faq, i) => <AccordionItem key={i} question={faq.q} answer={faq.a} data-id="element-4" />)}
      </div>
    </Section>;
}
function AccordionItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl bg-white overflow-hidden" data-id="element-5">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 text-left hover:bg-gray-50 transition-colors" data-id="element-6">
        <span className="font-medium text-gray-900" data-id="element-7">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-8" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-9" />}
      </button>

      <AnimatePresence data-id="element-10">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-11">
            <div className="p-5 pt-0 text-gray-600 border-t border-gray-100 mt-2" data-id="element-12">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}